module.exports = {"id":"213917","name":"Fábio Cardoso","rating":"73","photo":"./data/images/photos/3/213917.png","club":{"name":"Rangers","logo":"./data/images/clubs/Rangers.png"},"positions":["DC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FabioCardoso0.json
// module id = 1341
// module chunks = 0